import React from 'react';
import PropTypes from 'prop-types';

import FormToggle from './FormToggle.jsx';

function SimpleFilters({
  meta: { accessibilityAccess }, requiredAccessibilityAccess, setRequiredAccessibilityAccess,
}) {
  return (
    <section className="o-section">
      <div className="o-container">
        <div className="o-grid">
          <div className="o-col">
            <div className="c-ticket-selector__filter">
              <div className="c-ticket-selector__filter-options-mobile c-ticket-selector__filter-options-mobile--block">
                <div className="c-ticket-selector__filter-field">
                  <FormToggle
                    id={`${accessibilityAccess.value}-mobile`}
                    name={accessibilityAccess.value}
                    label={accessibilityAccess.title}
                    onChange={setRequiredAccessibilityAccess}
                    value={requiredAccessibilityAccess}
                  />
                </div>
              </div>

              <div className="c-ticket-selector__filter-options c-ticket-selector__filter-options--block">
                <div className="c-ticket-selector__filter-segment">
                  <div className="c-ticket-selector__filter-field">
                    <FormToggle
                      id={accessibilityAccess.value}
                      name={accessibilityAccess.value}
                      label={accessibilityAccess.title}
                      onChange={setRequiredAccessibilityAccess}
                      value={requiredAccessibilityAccess}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

SimpleFilters.propTypes = {
  meta: PropTypes.shape({
    accessibilityAccess: PropTypes.shape({
      title: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  requiredAccessibilityAccess: PropTypes.bool.isRequired,
  setRequiredAccessibilityAccess: PropTypes.func.isRequired,
};

export default SimpleFilters;
